import { NavLink } from "react-router-dom";

const TABS = [
  { to: "", label: "Dashboard" },
  { to: "categories", label: "Categories" },
  { to: "ingredients", label: "Ingredients" },
  { to: "menu", label: "Menu" },
  { to: "analysis", label: "Analysis" },
  { to: "invoices", label: "Invoices" },
  { to: "upload", label: "Upload" },
  { to: "help", label: "Help" },
] as const;

export function FoodHeader() {
  return (
    <header className="flex items-center justify-between border-b border-tribal-border bg-tribal-surface px-4 py-3">
      <div className="flex min-w-0 items-center gap-4">
        <h1 className="text-lg font-semibold tracking-tight">
          <span className="text-tribal-red">Tribal Axe</span> Food Cost
        </h1>
        <nav
          aria-label="Food views"
          className="hidden items-center gap-0.5 rounded-lg bg-black/30 p-0.5 sm:flex"
        >
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.to === ""}
              className={({ isActive }) =>
                `rounded-md px-3 py-1 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-tribal-border text-white"
                    : "text-tribal-muted hover:text-white"
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
